import AppRoutes from "./routes/AppRoutes";
import RouteScrollManager from "./components/common/RouteScrollManager/RouteScrollManager";
import OrganizationSchema from "./components/common/OrganizationSchema/OrganizationSchema";
import CookieConsent from "./components/common/CookieConsent/CookieConsent";
import { MotionProvider } from "./components/common/Motion";

function App() {
  return (
    <MotionProvider>
      <OrganizationSchema />
      <RouteScrollManager />
      <AppRoutes />
      <CookieConsent />
    </MotionProvider>
  );
}

export default App;
